export function PermissionsCategory(permissionName: string){
    return function permissionsCategory<T extends { new(...args: any[]): {} }>(PermissionsCategoryConstructor: T) {
        const baseClassProps = Object.getOwnPropertyNames(class { });
        const staticProps = Object.getOwnPropertyNames(PermissionsCategoryConstructor).filter(k => !baseClassProps.includes(k));
        for (const staticProp of staticProps) {
            Object.defineProperty(PermissionsCategoryConstructor, staticProp, {
                value: typeof PermissionsCategoryConstructor[staticProp] === 'number'
                    ? new PermissionValue({ val: PermissionsCategoryConstructor[staticProp], type: permissionName })
                    : PermissionsCategoryConstructor[staticProp]
            });
        }
        return PermissionsCategoryConstructor;
    }
}

export class PermissionValue {
    val: number = -1;
    type: string = "";

    public constructor(init?: Partial<PermissionValue>) {
        Object.assign(this, init);
    }
}